import React from "react";

const BathroomIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="#354052"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 12.325v-7a2 2 0 0 1 2-2h3v2.25m-7 15.75 1-1.5m15 1.5-1-1.5m-15-7.5h16a1 1 0 0 1 1 1v3a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-3a1 1 0 0 1 1-1"
    ></path>
  </svg>
);

export default BathroomIcon;
